import { apiSlice } from 'store/api/apiSlice';

export const menuCustomizationAPISlice: any = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getCategorizedMenuItems: builder.query({
      query: ({
        branchId,
        vegFilter = false,
        nonVegFilter = false,
        eggFilter = false,
        alcoholicFilter = false,
        nonAlcoholicFilter = false,
        sectionId,
      }) => {
        let filters: string[] = [];
        if (vegFilter) {
          filters.push(`&foodTypes=VEGETARIAN`);
        } else if (nonVegFilter) {
          filters.push(`&foodTypes=NON_VEGETARIAN`);
        } else if (eggFilter) {
          filters.push(`&foodTypes=EGGETARIAN`);
        } else if (alcoholicFilter) {
          filters.push(`&foodTypes=ALCOHOL`);
        } else if (nonAlcoholicFilter) {
          filters.push(`&foodTypes=BEVERAGES`);
        }

        let url = `/menuItemMaster/public/menu-item-grouped-category?branchId=${branchId}`;

        // add optional sectionId only if passed
        if (sectionId) {
          url += `&sectionId=${sectionId}`;
        }

        // add filters if any
        if (filters.length > 0) {
          url += filters.join('');
        }

        return {
          url,
          method: 'GET',
        };
      },
      keepUnusedDataFor: 0,
    }),

    getMenuItemByProductIdAndBranchId: builder.query({
      query: ({ productMasterId, branchId, sectionId }) => {
        let url = `/menuItemMaster/public/getCustomizationResponseForProductMaster?productMasterId=${productMasterId}&branchId=${branchId}`;

        if (sectionId) {
          url += `&sectionId=${sectionId}`;
        }

        return {
          url,
          method: 'GET',
        };
      },
      keepUnusedDataFor: 0,
    }),
  }),
});

export const { useGetCategorizedMenuItemsQuery, useGetMenuItemByProductIdAndBranchIdQuery } =
  menuCustomizationAPISlice;
